import {
  AddMaleIcon,
  BankIcon,
  DashboardSquareAddIcon,
  House04Icon,
  Male02Icon,
  SaleTag02Icon,
  SignatureIcon,
} from "@porchpass/ui";
import * as React from "react";
import type { ApplicationStep } from "../types/applicationTypes";

export const STEP_CONFIG: Record<
  ApplicationStep,
  { label: string; icon: (active: boolean) => React.ReactNode }
> = {
  summary: {
    label: "Summary",
    icon: (active: boolean) => (
      <DashboardSquareAddIcon
        variant="solid-rounded"
        size={14}
        className={active ? "text-primary" : "text-text-med"}
      />
    ),
  },
  "primary-borrower": {
    label: "Primary Borrower",
    icon: (active: boolean) => (
      <Male02Icon
        variant={active ? "bulk-rounded" : "stroke-rounded"}
        size={14}
        className={active ? "text-primary" : "text-text-med"}
      />
    ),
  },
  "co-borrower": {
    label: "Co-Borrower",
    icon: (active: boolean) => (
      <AddMaleIcon
        variant={active ? "bulk-rounded" : "stroke-rounded"}
        size={14}
        className={active ? "text-primary" : "text-text-med"}
      />
    ),
  },
  property: {
    label: "Land & Home",
    icon: (active: boolean) => (
      <House04Icon
        variant={active ? "bulk-rounded" : "stroke-rounded"}
        size={14}
        className={active ? "text-primary" : "text-text-med"}
      />
    ),
  },
  pricing: {
    label: "Pricing",
    icon: (active: boolean) => (
      <SaleTag02Icon
        variant={active ? "bulk-rounded" : "stroke-rounded"}
        size={14}
        className={active ? "text-primary" : "text-text-med"}
      />
    ),
  },
  lenders: {
    label: "Lenders",
    icon: (active: boolean) => (
      <BankIcon
        variant={active ? "bulk-rounded" : "stroke-rounded"}
        size={14}
        className={active ? "text-primary" : "text-text-med"}
      />
    ),
  },
  signature: {
    label: "Signatures",
    icon: (active: boolean) => (
      <SignatureIcon
        variant={active ? "bulk-rounded" : "stroke-rounded"}
        size={14}
        className={active ? "text-primary" : "text-text-med"}
      />
    ),
  },
};
